import React from "react";

const ClockAnimation: React.FC = () => {
  return (
    <svg
      viewBox="0 0 200 200"
      className="w-16 h-16"
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Clock face */}
      <circle cx="100" cy="100" r="100" fill="#a65430" />

      {/* Hour hand */}
      <line
        x1="100"
        y1="100"
        x2="100"
        y2="55"
        stroke="#ffffff"
        strokeWidth="8"
        strokeLinecap="round"
      >
        <animateTransform
          attributeName="transform"
          type="rotate"
          from="0 100 100"
          to="360 100 100"
          dur="24s"
          repeatCount="indefinite"
        />
      </line>

      {/* Minute hand */}
      <line
        x1="100"
        y1="100"
        x2="100"
        y2="35"
        stroke="#ffffff"
        strokeWidth="6"
        strokeLinecap="round"
      >
        <animateTransform
          attributeName="transform"
          type="rotate"
          from="0 100 100"
          to="360 100 100"
          dur="4s"
          repeatCount="indefinite"
        />
      </line>
    </svg>
  );
};

export default ClockAnimation;
